import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

// Custom hook for idle timeout
const useIdleTimeout = (timeoutMinutes = 5) => {
  useEffect(() => {
    const timeoutMs = timeoutMinutes * 60 * 1000; // Convert minutes to milliseconds
    let timeoutId;

    const resetTimer = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        localStorage.removeItem("definiteagent");
        window.location.href = "/login";
      }, timeoutMs);
    };

    // Initial timer setup
    resetTimer();

    // Events that reset the timer
    const events = [
      "mousedown", "mousemove", "keypress", 
      "scroll", "touchstart", "click"
    ];

    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Cleanup
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [timeoutMinutes]);
};

const Authmiddleware = (props) => {
  useIdleTimeout(5); // 5 minutes

  if (!localStorage.getItem("definiteagent")) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
